import React, { useCallback, useEffect, useState } from "react";

import { beautifyJson } from "Constant/string";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import Validator from "validator";

import {
    editServiceDetail,
    getAuthServicesList,
    getServiceDetail,
    postServiceAsync,
} from "helpers/leads/stepHelpers/sendStep1ToServis";

import CreateAuthServiceModal from "components/organisms/CreateAuthServiceModal/CreateAuthServiceModal";

import { lastAddedService } from "../../../redux/slices/leadsWizardSourceDestination/leadsWizardSourceDestination.slice";
import SwalAlertComp from "../../SwalAlert";
import Content from "./components/Content";
import Footer from "./components/Footer";
import Header from "./components/Header";

/**
 * @note divided into content header and footer as part 1 revamp
 */

const CreateWebService = ({
    destinationType,
    handleCloseServiceModal,
    businessIdState,
    newAddedService,
    runDispatchAfterCreate,
    serviceId,
    destinationSelections,
}) => {
    const [isAuthServiceModalOpen, setIsAuthServiceModalOpen] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [show, setShow] = useState(true);
    const [authenticationType, setAuthenticationType] = useState("no-auth");
    const [key, setKey] = useState("");
    const [variable, setVariable] = useState("");
    const [sendIn, setSendIn] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [token, setToken] = useState("");
    const [maskedCredentials, setMaskedCredentials] = useState({
        username: false,
        password: false,
        token: false,
        key: false,
        variable: false,
    });
    const [originalCredentials, setOriginalCredentials] = useState({
        username: "",
        password: "",
        token: "",
        key: "",
        variable: "",
        send_in: "",
    });
    const [name, setName] = useState("");
    const [request, setRequest] = useState("post");
    const [status, setStatus] = useState("active");
    const [type, setType] = useState("Form-Data");
    const [url, setUrl] = useState("");
    const [fields, setFields] = useState([]);
    const [jsons, setJsons] = useState([]);
    const [error, setError] = useState({});
    const [textbox, setTextbox] = useState("");
    const [selectedAuthServiceID, setSelectedAuthServiceId] = useState(null);
    const [responseHandlerHandler, setResponseHandlerHandler] = useState(false);
    const [selectedResponseHandler, setSelectedResponseHandler] =
        useState("header");
    const [responseStatus, setResponseStatus] = useState("");
    const [textValue, setTextValue] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [isLoadingFetchLoading, setIsLoadingFetchLoading] = useState(false);

    const [selectedContainsOrEquels, setSelectedContainsOrEquels] =
        useState("contains");
    const [selectedTextOrJson, setSelectedTextOrJson] = useState("text");
    const [fieldList, setFieldList] = useState(
        destinationType && destinationType !== "http"
            ? [
                  { field: "FIRST NAME", required: false },
                  { field: "LAST NAME", required: false },
                  { field: " COMPANY", required: false },
                  { field: "EMAIL", required: false },
                  { field: "PHONE", required: false },
              ]
            : [{ field: "", required: false }],
    );
    const [jsonList, setJsonList] = useState([{ key: "", value: "" }]);
    const dispatch = useDispatch();

    const language = useSelector((state) => state.languagesState.languages);

    const handleClose = useCallback(() => {
        setShow(false);
        handleCloseServiceModal();
    }, [setShow, handleCloseServiceModal]);

    const postService = useCallback(
        async (data) => {
            let response = await postServiceAsync(data);
            if (response.status) {
                if (newAddedService) {
                    newAddedService(response.data ?? "");
                    dispatch(lastAddedService(response.data ?? ""));
                }
                if (runDispatchAfterCreate !== undefined) {
                    runDispatchAfterCreate();
                }
                handleCloseServiceModal();
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response.message && response.message,
                    icon: "error",
                });
            }
        },
        [
            newAddedService,
            dispatch,
            runDispatchAfterCreate,
            handleCloseServiceModal,
            language,
        ],
    );

    const editService = useCallback(
        async (data) => {
            let response = await editServiceDetail(serviceId, data);
            if (response.status) {
                if (newAddedService) {
                    newAddedService(response.data ?? "");
                    dispatch(lastAddedService(response.data ?? ""));
                }
                if (runDispatchAfterCreate !== undefined) {
                    runDispatchAfterCreate();
                }
                SwalAlertComp({
                    title: language?.delete_swal_modal?.success ?? "Success",
                    message: response.message && response.message,
                    icon: "success",
                    timer: 3000,
                });
                handleCloseServiceModal();
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response.message && response.message,
                    icon: "error",
                });
            }
        },
        [
            newAddedService,
            runDispatchAfterCreate,
            handleCloseServiceModal,
            language,
            serviceId,
            dispatch,
        ],
    );

    const validate = useCallback(() => {
        const error = {};
        switch (authenticationType) {
            case "api-key":
                if (isEdit) {
                    // In edit mode, only validate if changed
                    if (key !== originalCredentials.key && key === "")
                        error.key = true;
                    if (
                        variable !== originalCredentials.variable &&
                        variable === ""
                    )
                        error.variable = true;
                } else {
                    // In create mode, always validate
                    if (key === "") error.key = true;
                    if (variable === "") error.variable = true;
                }
                break;
            case "basic":
                if (isEdit) {
                    // In edit mode, only validate if changed
                    if (
                        username !== originalCredentials.username &&
                        username === ""
                    )
                        error.username = true;
                    if (
                        password !== originalCredentials.password &&
                        password === ""
                    )
                        error.password = true;
                } else {
                    // In create mode, always validate
                    if (username === "") error.username = true;
                    if (password === "") error.password = true;
                }
                break;
            case "bearer":
                if (isEdit) {
                    // In edit mode, only validate if changed
                    if (token !== originalCredentials.token && token === "")
                        error.token = true;
                } else {
                    // In create mode, always validate
                    if (token === "") error.token = true;
                }
                break;
            default:
                break;
        }
        switch (type) {
            case "Raw-Json":
                try {
                    const parsedJson = JSON.parse(textbox);
                    // Check if JSON is empty object or empty array
                    if (
                        (typeof parsedJson === "object" &&
                            parsedJson !== null &&
                            Object.keys(parsedJson).length === 0) ||
                        (Array.isArray(parsedJson) && parsedJson.length === 0)
                    ) {
                        error.textbox = true;
                    }
                } catch (err) {
                    error.textbox = true;
                }
                if (textbox === "") error.textbox = true;
                break;
            case "Raw-Xml":
                if (textbox === "") error.textbox = true;
                break;
            case "Raw-Text":
                if (textbox === "") error.textbox = true;
                break;
            default:
                break;
        }
        if (name === "") error.name = true;

        // URL validation
        if (url === "") {
            error.url = `${
                language?.footer?.this_field_is_required ??
                "This field is required"
            }`;
        } else if (!Validator.isURL(url)) {
            error.url = "The entered text must conform to the URL format!";
        }

        if (
            selectedResponseHandler &&
            selectedResponseHandler === "body" &&
            selectedTextOrJson &&
            selectedTextOrJson === "json"
        ) {
            let jsonError =
                jsons.length > 0 && jsons.filter((item) => item.name === "");
            if (jsonError.length > 0) {
                let emptyKeyIndexes = jsonError.map((item) =>
                    jsons.indexOf(item),
                );
                error.jsons = {
                    code: `${
                        language?.footer?.this_field_is_required ??
                        "This field is required"
                    }`,
                    index: emptyKeyIndexes,
                };
            }
        }
        let fieldError =
            fields.length > 0 && fields.filter((item) => item.name === "");
        if (fieldError.length > 0 && type !== "Raw-Json") {
            let emptyNameIndexes = fieldError.map((item) =>
                fields.indexOf(item),
            );
            error.fields = {
                code: `${
                    language?.footer?.this_field_is_required ??
                    "This field is required"
                }`,
                index: emptyNameIndexes,
            };
        }
        return error;
    }, [
        authenticationType,
        key,
        variable,
        password,
        username,
        token,
        type,
        textbox,
        name,
        url,
        selectedTextOrJson,
        selectedResponseHandler,
        jsons,
        fields,
        language,
        isEdit,
        originalCredentials,
    ]);
    const isValidJson = useCallback(() => {
        if (type !== "Raw-Json") return true;
        try {
            const parsedJson = JSON.parse(textbox);
            // Check if JSON is empty object or empty array
            if (
                (typeof parsedJson === "object" &&
                    parsedJson !== null &&
                    Object.keys(parsedJson).length === 0) ||
                (Array.isArray(parsedJson) && parsedJson.length === 0)
            ) {
                return false;
            }
            return true;
        } catch (error) {
            return false;
        }
    }, [type, textbox]);
    const handleClick = useCallback(async () => {
        const error = validate();
        if (type === "Raw-Json" && !isValidJson(textbox)) {
            SwalAlertComp({
                title: "Validation Error",
                message:
                    "Please input valid JSON. Empty objects or arrays are not allowed.",
                icon: "error",
            });
            return;
        }
        setError(error);
        if (Object.keys(error).length === 0) {
            setIsLoading(true);

            let credentials = {};
            switch (authenticationType) {
                case "api-key":
                    // In edit mode, only include changed credentials
                    // In create mode, include all credentials
                    if (isEdit) {
                        if (key !== originalCredentials.key)
                            credentials.key = key;
                        if (variable !== originalCredentials.variable)
                            credentials.variable = variable;
                        if (sendIn !== originalCredentials.send_in)
                            credentials.send_in = sendIn;
                    } else {
                        if (key) credentials.key = key;
                        if (variable) credentials.variable = variable;
                        if (sendIn) credentials.send_in = sendIn;
                    }
                    break;
                case "basic":
                    if (isEdit) {
                        if (username !== originalCredentials.username)
                            credentials.username = username;
                        if (password !== originalCredentials.password)
                            credentials.password = password;
                    } else {
                        if (username) credentials.username = username;
                        if (password) credentials.password = password;
                    }
                    break;
                case "bearer":
                    if (isEdit) {
                        if (token !== originalCredentials.token)
                            credentials.token = token;
                    } else {
                        if (token) credentials.token = token;
                    }
                    break;
            }
            let responseMatchingData;
            if (destinationType && destinationType === "http") {
                if (selectedResponseHandler === "header") {
                    responseMatchingData = {
                        type: selectedResponseHandler,
                        response: {
                            status: responseStatus,
                        },
                    };
                } else {
                    if (selectedTextOrJson && selectedTextOrJson === "text") {
                        responseMatchingData = {
                            type: selectedResponseHandler,
                            response: {
                                format: selectedTextOrJson,
                                [selectedContainsOrEquels]: textValue,
                            },
                        };
                    } else {
                        responseMatchingData = {
                            type: selectedResponseHandler,
                            response: {
                                format: selectedTextOrJson,
                                params:
                                    jsonList &&
                                    jsonList.length > 0 &&
                                    jsonList.map((item) => ({
                                        [item.key]: item.value,
                                    })),
                            },
                        };
                    }
                }
            }

            const postOrPutService = {
                business_id: [businessIdState],
                ...(Object.keys(credentials).length > 0 ? { credentials } : {}),
                auth_type:
                    authenticationType === "api-key"
                        ? "apikey"
                        : authenticationType === "no-auth"
                          ? "noauth"
                          : authenticationType,
                name: name,
                method: request,
                status: status === "active" ? 1 : 0,
                type:
                    type === "Form-Data" || type === "Form-Url-Encoded"
                        ? "form_params"
                        : "json",
                ...(textbox && (type === "Raw-Json" || type === "json")
                    ? {
                          type_data:
                              type === "Raw-Json" || type === "json"
                                  ? JSON.parse(textbox)
                                  : textbox,
                      }
                    : {}),
                url: url,
                ...(type !== "Raw-Json" && type !== "json"
                    ? {
                          fields:
                              fields &&
                              fields.length > 0 &&
                              fields.map((item) => ({
                                  name: item.name,
                                  type: item.type?.replace(/\s/g, "_"),
                                  required: item.required && item.required,
                              })),
                      }
                    : {}),

                destination_type_id: destinationType && destinationType,
                response_matching:
                    destinationType && destinationType === "http"
                        ? responseMatchingData
                        : null,
                ...(selectedAuthServiceID
                    ? {
                          auth_service_id: selectedAuthServiceID,
                      }
                    : {}),
            };

            if (isEdit) {
                await editService(postOrPutService);
            } else {
                await postService(postOrPutService);
            }
            setIsLoading(false);
        }
    }, [
        textbox,
        authenticationType,
        businessIdState,
        destinationType,
        editService,
        fields,
        isEdit,
        jsonList,
        key,
        name,
        password,
        postService,
        request,
        responseStatus,
        selectedContainsOrEquels,
        selectedResponseHandler,
        selectedTextOrJson,
        selectedAuthServiceID,
        sendIn,
        status,
        textValue,
        token,
        type,
        url,
        username,
        validate,
        variable,
        isValidJson,
        originalCredentials,
    ]);

    useEffect(() => {
        if (serviceId !== undefined) {
            setIsEdit(true);
            getDetail(serviceId);
        } else {
            setIsEdit(false);
        }
    }, [serviceId]);

    const getDetail = useCallback(
        async (id) => {
            setIsLoadingFetchLoading(true);
            let response = await getServiceDetail(id);
            if (response?.status) {
                let serviceDetail = response?.data;
                setName(serviceDetail?.name);
                setUrl(serviceDetail?.url);
                setSelectedAuthServiceId(serviceDetail?.auth_service_id);
                setRequest(serviceDetail?.method?.toLowerCase());

                if (serviceDetail?.auth_type === "apikey") {
                    setAuthenticationType("api-key");
                } else if (serviceDetail?.auth_type === "noauth") {
                    setAuthenticationType("no-auth");
                } else {
                    setAuthenticationType(serviceDetail?.auth_type);
                }

                // Extract credentials based on auth_type
                if (serviceDetail?.credentials) {
                    const creds = serviceDetail.credentials;
                    const masked = {};
                    const original = {
                        username: "",
                        password: "",
                        token: "",
                        key: "",
                        variable: "",
                        send_in: "",
                    };

                    if (serviceDetail?.auth_type === "basic") {
                        setUsername(creds.username || "");
                        setPassword(creds.password || "");
                        masked.username =
                            creds.username?.includes("***") || false;
                        masked.password =
                            creds.password?.includes("***") || false;
                        original.username = creds.username || "";
                        original.password = creds.password || "";
                    } else if (serviceDetail?.auth_type === "apikey") {
                        setKey(creds.key || "");
                        setVariable(creds.variable || "");
                        setSendIn(creds.send_in || "");
                        masked.key = creds.key?.includes("***") || false;
                        masked.variable =
                            creds.variable?.includes("***") || false;
                        original.key = creds.key || "";
                        original.variable = creds.variable || "";
                        original.send_in = creds.send_in || "";
                    } else if (serviceDetail?.auth_type === "bearer") {
                        setToken(creds.token || "");
                        masked.token = creds.token?.includes("***") || false;
                        original.token = creds.token || "";
                    }

                    setMaskedCredentials(masked);
                    setOriginalCredentials(original);
                }

                if (serviceDetail?.type === "form_params") {
                    setType("Form-Data");
                } else if (serviceDetail?.type === "json") {
                    setType("Raw-Json");
                } else {
                    setType(serviceDetail?.type);
                }
                setTextbox(
                    beautifyJson(
                        serviceDetail?.type === "json"
                            ? serviceDetail?.raw_fields
                            : serviceDetail?.type_data,
                    ),
                );
                setStatus(serviceDetail?.status === 1 ? "active" : "passive");

                let serviceFields = JSON.parse(serviceDetail?.fields);
                serviceFields = serviceFields.map((x) => ({
                    ...x,
                    field: x.name,
                }));
                setFieldList(serviceFields);

                let responseMatching = JSON.parse(
                    serviceDetail?.response_matching,
                );
                setResponseHandlerHandler(false);
                setSelectedResponseHandler(responseMatching?.type);
                setResponseStatus(responseMatching?.response?.status);
                if (responseMatching?.response?.contains !== undefined) {
                    setTextValue(responseMatching?.response?.contains);
                    setSelectedContainsOrEquels("contains");
                } else if (responseMatching?.response?.equals !== undefined) {
                    setTextValue(responseMatching?.response?.equals);
                    setSelectedContainsOrEquels("equals");
                }
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response.message && response.message,
                    icon: "error",
                });
            }
            setIsLoadingFetchLoading(false);
        },
        [
            setName,
            setUrl,
            setAuthenticationType,
            setType,
            setTextbox,
            setStatus,
            setFieldList,
            setResponseHandlerHandler,
            setSelectedResponseHandler,
            setResponseStatus,
            setTextValue,
            setSelectedContainsOrEquels,
            language,
            setIsLoadingFetchLoading,
        ],
    );
    const [authServices, setAuthServices] = useState([{ field: "" }]);
    const [isLoadingAuthServices, setIsLoadingAuthServices] = useState(false);

    const getAuthServices = useCallback(async () => {
        setIsLoadingAuthServices(true);
        const response = await getAuthServicesList();
        setAuthServices(
            response?.data?.map(({ id, name }) => ({
                label: name,
                value: id,
            })),
        );
        setIsLoadingAuthServices(false);
    }, [setIsLoadingAuthServices, setAuthServices]);

    useEffect(() => {
        getAuthServices();
    }, []);

    // Clear credential errors when authentication type changes
    useEffect(() => {
        setError((prevError) => {
            const newError = { ...prevError };
            delete newError.username;
            delete newError.password;
            delete newError.token;
            delete newError.key;
            delete newError.variable;
            return newError;
        });
    }, [authenticationType]);

    return (
        <div>
            {isAuthServiceModalOpen && (
                <CreateAuthServiceModal
                    onClose={() => setIsAuthServiceModalOpen(false)}
                    setSelectedAuthServiceId={setSelectedAuthServiceId}
                    onCreateSuccess={(id) => {
                        setSelectedAuthServiceId(id);
                        getAuthServices();
                    }}
                />
            )}
            {!isAuthServiceModalOpen && (
                <Modal
                    className="new-ui-modal create-modal"
                    show={show}
                    onHide={handleClose}
                    style={{ display: "none" }}
                >
                    <Header
                        isEdit={isEdit}
                        destinationSelections={destinationSelections}
                    />
                    <Content
                        authServices={authServices}
                        isLoadingAuthServices={isLoadingAuthServices}
                        error={error}
                        setUrl={setUrl}
                        isEdit={isEdit}
                        setRequest={setRequest}
                        authenticationType={authenticationType}
                        setAuthenticationType={setAuthenticationType}
                        setKey={setKey}
                        variable={variable}
                        sendIn={sendIn}
                        name={name}
                        url={url}
                        request={request}
                        username={username}
                        password={password}
                        token={token}
                        type={type}
                        textbox={textbox}
                        fieldList={fieldList}
                        destinationType={destinationType}
                        responseHandlerHandler={responseHandlerHandler}
                        selectedResponseHandler={selectedResponseHandler}
                        responseStatus={responseStatus}
                        selectedTextOrJson={selectedTextOrJson}
                        selectedContainsOrEquels={selectedContainsOrEquels}
                        selectedAuthServiceID={selectedAuthServiceID}
                        status={status}
                        apiKey={key}
                        jsonList={jsonList}
                        textValue={textValue}
                        maskedCredentials={maskedCredentials}
                        setVariable={setVariable}
                        setSendIn={setSendIn}
                        setUsername={setUsername}
                        setPassword={setPassword}
                        setToken={setToken}
                        setTextbox={setTextbox}
                        setFieldList={setFieldList}
                        setFields={setFields}
                        setJsons={setJsons}
                        setResponseHandlerHandler={setResponseHandlerHandler}
                        setSelectedResponseHandler={setSelectedResponseHandler}
                        setResponseStatus={setResponseStatus}
                        setSelectedTextOrJson={setSelectedTextOrJson}
                        setSelectedContainsOrEquels={
                            setSelectedContainsOrEquels
                        }
                        setType={setType}
                        setJsonList={setJsonList}
                        setTextValue={setTextValue}
                        setStatus={setStatus}
                        setName={setName}
                        setSelectedAuthServiceId={setSelectedAuthServiceId}
                        setIsAuthServiceModalOpen={setIsAuthServiceModalOpen}
                        setMaskedCredentials={setMaskedCredentials}
                        isLoadingFetchLoading={isLoadingFetchLoading}
                    />

                    <Footer
                        isEdit={isEdit}
                        fieldList={fieldList}
                        handleClick={handleClick}
                        handleClose={handleClose}
                        isLoading={isLoading}
                        type={type}
                        textbox={textbox}
                    />
                </Modal>
            )}
        </div>
    );
};

export default CreateWebService;
